import { WeatherProductFileInfo } from '@fe/weather';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WeatherAccessInfo, WeatherInitInfo, type WeatherUpdatedInfo } from '../../../webscoket/services/worker-weather-service';
import { stopPlayback } from '../reducers/playback';

export interface WeatherSlice {
    // TODO: does this need to be in state? ~ml: no, but it can
    live: {
        products: WeatherProductFileInfo[];
        accessInfo: WeatherAccessInfo | null;
    };
    playback: {
        /** Product timestamps as the came in from the server */
        products: WeatherProductFileInfo[];
        /** IDs of all products that were recorded  */
        available: number[];
    };
    authorized: number[];
}

const initialState: WeatherSlice = {
    live: {
        products: [],
        accessInfo: null
    },
    playback: {
        products: [],
        available: []
    },
    authorized: []
};

export const weatherSlice = createSlice({
    name: 'weather',
    initialState: initialState,
    reducers: {
        initPlaybackWeather(state, params: PayloadAction<{ availableWeather: number[] }>) {
            state.playback.available = params.payload.availableWeather;
        },
        updateWeatherAccessInfo(state, params: PayloadAction<WeatherAccessInfo>) {
            state.live.accessInfo = params.payload;
        },
        initWeatherProducts(state, params: PayloadAction<WeatherInitInfo>) {
            const toUpdate = params.payload.type === 'live' ? state.live : state.playback;
            toUpdate.products = params.payload.products;

            if (params.payload.type === 'live') {
                state.authorized = params.payload.authorized;
            }
        },
        updateWeatherProducts(state, params: PayloadAction<WeatherUpdatedInfo>) {
            // TODO: this happens relatively frequently, every 1-5 update cycles
            // In playback mode this can happen couple times a second, investigate if it's going to cause any performance issues
            const toUpdate = params.payload.type === 'live' ? state.live : state.playback;

            for (const prod of params.payload.products) {
                const idx = toUpdate.products.findIndex((x) => x.id === prod.id);
                if (idx !== -1) {
                    toUpdate.products[idx] = prod;
                } else {
                    toUpdate.products.push(prod);
                }
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(stopPlayback.fulfilled, (state) => {
            state.playback = {
                products: [],
                available: []
            };
        });
    }
});

export const { updateWeatherProducts, initWeatherProducts, updateWeatherAccessInfo, initPlaybackWeather } = weatherSlice.actions;
